import { Box } from '@mui/material';
import Background from '../../assets/images/bg/collection_2026/star_bg_gray.png';
import Logo from '../../assets/images/logo/starcard_club_dark.png';

const RegisterLayout = ({ children, background }) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100dvh',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        background: `url(${background || Background}) center center / cover, #FAFAFA`,
      }}
    >
      <Box>
        <Box component={'img'} src={Logo} alt="Starcard Club Logo" sx={{ height: '60px' }} />
        {children}
      </Box>
    </Box>
  );
};
export default RegisterLayout;
